//记得在 src\components\lang\zhLoad.js 里面添加对象
const client = {
  name:'系统名',
  author:'作者',
  currentVersion: '当前版本号',
  thisUpdateVersionNumber: '本次更新版本',
  description: '描述',
  msg: {
  }
};
export default client



// WEBPACK FOOTER //
// ./src/page/sm/pda/lang/index.en.js